import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";

//Images
import dashboardImage from "../assets/images/dashboard.svg";
import branchesImage from "../assets/images/branches.svg";
import couponImage from "../assets/images/coupon.svg";
import loyaltyImage from "../assets/images/loyalty.svg";
import analyticsImage from "../assets/images/analytics.svg";
import subscriptionsImage from "../assets/images/subscriptions.svg";
import carbonReportImage from "../assets/images/carbon_report.svg";
import chatImage from "../assets/images/chat.svg";
import notificationImage from "../assets/images/notification.svg";
import profile1Image from "../assets/images/profile.svg";
import offerRedeemImg from "../assets/images/redeem-offers-icon.svg";
import performanceImg from "../assets/images/performance.svg";
import supportImg from "../assets/images/support.svg";
import Skeleton from "react-loading-skeleton";
import dollarImg from "../assets/images/dollar.svg";
import calculationImg from "../assets/images/calculation.svg";

const Sidebar = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const location = useLocation();

  const { authUser, loading } = useSelector((state) => state.userStore);

  const userType = localStorage.getItem("userType");

  const loyaltyRoutes = ["/point-calculation", "/customer-redemption-offers"];
  const reportRoutes = [
    "/offer-perfomace-report",
    "/customer-interaction-report",
    "/loyalty-program-report",
    "/transactions",
  ];

  const [isLoyaltyDropdownActive, setIsLoyaltyDropdownActive] = useState(
    loyaltyRoutes.includes(location.pathname)
  );
  const [isReportDropdownActive, setIsReportDropdownActive] = useState(
    reportRoutes.includes(location.pathname)
  );

  const handleNavigation = (e, path) => {
    if (path === "/profile" || path === "/branch-profile") {
      return;
    }
    if (userType == 2 && authUser && (authUser?.is_profile_complete == 1 || authUser?.is_profile_complete === "1")) {
      e.preventDefault();
      Swal.fire({
        title: t("Update your Profile First"),
        icon: "warning",
        confirmButtonColor: "#837fd8",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/profile");
        }
      });
    }
  };

  const handleDropdownClick = (e) => {
    if (userType == 2 && authUser && (authUser?.is_profile_complete == 1 || authUser?.is_profile_complete === "1")) {
      e.preventDefault();
      e.stopPropagation();
      Swal.fire({
        title: t("Update your Profile First"),
        icon: "warning",
        confirmButtonColor: "#837fd8",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/profile");
        }
      });
    }
  };

  useEffect(() => {
    setIsLoyaltyDropdownActive(loyaltyRoutes.includes(location.pathname));
  }, [location.pathname]);
  useEffect(() => {
    setIsReportDropdownActive(reportRoutes.includes(location.pathname));
  }, [location.pathname]);

  return (
    <>
      <div className="dashboard-left-content">
        <div className="profile-section text-center">
          {loading ? (
            <Skeleton width={100} height={100} />
          ) : (
            <img
              src={authUser?.profile_image}
              alt="Profile"
              className="profile-image"
            />
          )}
          <h2>{authUser?.name}</h2>
          <p>{authUser?.national_address}</p>
        </div>
        <ul className="dashboard-menu">
          <li>
            <Link
              to="/dashboard"
              className={location.pathname == "/dashboard" ? "active" : ""}
              onClick={(e) => handleNavigation(e, "/dashboard")}
            >
              <img src={dashboardImage} alt="" /> {t("Dashboard")}
            </Link>
          </li>

          {userType == 2 && (
            <li>
              <Link
                to="/branches"
                className={
                  location.pathname == "/branches" ||
                    location.pathname == "/add-branch" ||
                    location.pathname.includes("/view-branch") ||
                    location.pathname.includes("/edit-branch")
                    ? "active"
                    : ""
                }
                onClick={(e) => handleNavigation(e, "/branches")}
              >
                <img src={branchesImage} alt="" /> {t("Branches")}
              </Link>
            </li>
          )}
          {userType == 3 && (
            <li>
              <Link
                to="/offers-redeem"
                className={
                  location.pathname == "/offers-redeem" ? "active" : ""
                }
              >
                <img src={offerRedeemImg} alt="" /> {t("Offers Redeem")}
              </Link>
            </li>
          )}

          <li>
            <Link
              to="/offers"
              className={
                location.pathname == "/offers" ||
                  location.pathname == "/add-offer" ||
                  location.pathname.includes("/view-offer") ||
                  location.pathname.includes("/edit-offer")
                  ? "active"
                  : ""
              }
              onClick={(e) => handleNavigation(e, "/offers")}
            >
              <img src={couponImage} alt="" /> {t("Offers")}
            </Link>
          </li>

          {/* {userType == "2" && (
            <li>
              <Link
                to="/customer-second-time-offer-pending"
                className={
                  location.pathname == "/customer-second-time-offer-pending"
                    ? "active"
                    : ""
                }
              >
                <img src={couponImage} alt="" />
                {t("Customer Second Time Offer Pending")}
              </Link>
            </li>
          )} */}

          {/* <li>
            <Link
              to="/loyalty-program"
              className={
                location.pathname == "/loyalty-program" ? "active" : ""
              }
            >
              <img src={loyaltyImage} alt="" /> {t("Loyalty Program")}
            </Link>
          </li> */}

          {userType == "2" && (
            <li className="nav-item">
              <a
                className={`dropdown-toggle d-flex align-items-center ${isLoyaltyDropdownActive ? "" : "collapsed"
                  }`}
                data-bs-toggle="collapse"
                data-bs-target="#loyaltySubmenu"
                aria-expanded={isLoyaltyDropdownActive}
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  if (userType == 2 && authUser && (authUser?.is_profile_complete == 1 || authUser?.is_profile_complete === "1")) {
                    handleDropdownClick(e);
                  } else {
                    setIsLoyaltyDropdownActive(!isLoyaltyDropdownActive);
                  }
                }}
              >
                <img src={loyaltyImage} alt="" className="" />{" "}
                <span>{t("Loyalty Program")}</span>
                <i className="fas fa-chevron-down ms-auto"></i>
              </a>
              <ul
                className={`collapse submenu list-unstyled ${isLoyaltyDropdownActive ? "show" : ""
                  }`}
                id="loyaltySubmenu"
              >
                <li>
                  <Link
                    to="/point-calculation"
                    className={
                      location.pathname == "/point-calculation" ? "active" : ""
                    }
                    onClick={(e) => handleNavigation(e, "/point-calculation")}
                  >
                    <img src={calculationImg} alt="" />
                    {t("Points calculation")}
                  </Link>
                </li>
                <li>
                  <Link
                    to="/customer-redemption-offers"
                    className={
                      location.pathname == "/customer-redemption-offers"
                        ? "active"
                        : ""
                    }
                    onClick={(e) => handleNavigation(e, "/customer-redemption-offers")}
                  >
                    <img src={couponImage} alt="" />
                    {t("Customer Redemption Offer")}
                  </Link>
                </li>
              </ul>
            </li>
          )}

          {/* <li>
            <Link
              to="/analysis"
              className={location.pathname == "/analysis" ? "active" : ""}
            >
              <img src={analyticsImage} alt="" /> {t("Analytics Statistics")}
            </Link>
          </li> */}

          <li>
            <Link
              to="/analysis"
              className={location.pathname == "/analysis" ? "active" : ""}
              onClick={(e) => handleNavigation(e, "/analysis")}
            >
              <img src={analyticsImage} alt="" /> {t("Analytics Statistics")}
            </Link>
          </li>

          {userType == "2" && (
            <li>
              <Link
                to="/subscription"
                className={location.pathname == "/subscription" ? "active" : ""}
                onClick={(e) => handleNavigation(e, "/subscription")}
              >
                <img src={subscriptionsImage} alt="" />
                {t("Subscriptions")}
              </Link>
            </li>
          )}

          <li className="nav-item">
            <a
              className={`dropdown-toggle d-flex align-items-center ${isReportDropdownActive ? "" : "collapsed"
                }`}
              data-bs-toggle="collapse"
              data-bs-target="#reportsSubmenu"
              aria-expanded={isReportDropdownActive}
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                if (userType == 2 && authUser && (authUser?.is_profile_complete == 1 || authUser?.is_profile_complete === "1")) {
                  handleDropdownClick(e);
                } else {
                  setIsReportDropdownActive(!isReportDropdownActive);
                }
              }}
            >
              <img src={carbonReportImage} alt="" className="" />{" "}
              <span>{t("Reports")}</span>
              <i className="fas fa-chevron-down"></i>
            </a>
            <ul
              className={`collapse submenu list-unstyled ${isReportDropdownActive ? "show" : ""
                }`}
              id="reportsSubmenu"
            >
              <li>
                <Link
                  to="/offer-perfomace-report"
                  className={
                    location.pathname == "/offer-perfomace-report"
                      ? "active"
                      : ""
                  }
                  onClick={(e) => handleNavigation(e, "/offer-perfomace-report")}
                >
                  <img src={performanceImg} alt="" />{" "}
                  {t("Offer Performance Reports")}
                </Link>
              </li>
              <li>
                <Link
                  to="/customer-interaction-report"
                  className={
                    location.pathname == "/customer-interaction-report"
                      ? "active"
                      : ""
                  }
                  onClick={(e) => handleNavigation(e, "/customer-interaction-report")}
                >
                  <img src={supportImg} alt="" /> {t("Customer Interaction")}
                </Link>
              </li>
              <li>
                <Link
                  to="/loyalty-program-report"
                  className={
                    location.pathname == "/loyalty-program-report"
                      ? "active"
                      : ""
                  }
                  onClick={(e) => handleNavigation(e, "/loyalty-program-report")}
                >
                  <img src={loyaltyImage} alt="" /> {t("Loyalty Program")}
                </Link>
              </li>
              <li>
                <Link
                  className={
                    location.pathname == "/transactions" ? "active" : ""
                  }
                  to="/transactions"
                  onClick={(e) => handleNavigation(e, "/transactions")}
                >
                  <img src={dollarImg} alt="" /> {t("Transaction")}
                </Link>
              </li>
            </ul>
          </li>

          <li>
            <Link
              to="/chats"
              className={location.pathname == "/chats" ? "active" : ""}
              onClick={(e) => handleNavigation(e, "/chats")}
            >
              <img src={chatImage} alt="" /> {t("Chat")}{" "}
            </Link>
          </li>

          {userType == "2" && authUser?.is_notification_enabled == "1" && (
            <li>
              <Link
                to="/notification"
                className={location.pathname == "/notification" ? "active" : ""}
                onClick={(e) => handleNavigation(e, "/notification")}
              >
                <img src={notificationImage} alt="" /> {t("Notification")}{" "}
              </Link>
            </li>
          )}

          {userType == "2" && (
            <li>
              <Link
                to="/profile"
                className={location.pathname == "/profile" ? "active" : ""}
              >
                <img src={profile1Image} alt="" />
                {t("Profile")}
              </Link>
            </li>
          )}

          {userType == "3" && (
            <li>
              <Link
                to="/branch-profile"
                className={
                  location.pathname == "/branch-profile" ? "active" : ""
                }
              >
                <img src={profile1Image} alt="" />
                {t("Profile")}
              </Link>
            </li>
          )}
        </ul>
      </div>
    </>
  );
};

export default Sidebar;
